import { clsx } from 'clsx';

import type { JsObject } from 'utils/check';
import type { SelectProps, TextFieldProps } from 'ui';
import { SelectArrowIcon } from 'ui/icons';

interface AtomProps {
  className?: string;
  style?: Record<string, string | number>;
}

type UseSelectView = <OPTION_TYPE extends JsObject = {}>(
  props: SelectProps<OPTION_TYPE>,
  classes: Record<string, string>,
  options: {
    popupOpened: boolean;
  },
) => {
  textFieldProps: TextFieldProps;
  bricksContainerProps: AtomProps;
  bricksPlaceholderProps: AtomProps;
  brickProps: AtomProps;
  brickCloserContainerProps: AtomProps;
  popupContainerProps: AtomProps;
  popupPaperProps: AtomProps;
  popupOptionsListProps: AtomProps;
  popupOptionProps: AtomProps;
  popupOptionInfoProps: AtomProps;
  popupOptionTextContainerProps: AtomProps;
  popupOptionTitleProps: AtomProps;
  popupOptionSubTitleProps: AtomProps;
  popupOptionIndicatorProps: { className?: (isSelected: boolean) => string };
  popupOptionImageProps: AtomProps;
};

export const useSelectView: UseSelectView = (props, classes, options) => {
  const { value, selectedHighlight, forceTooltip, readOnly, ...textFieldProps } = props;

  return {
    textFieldProps: {
      ...textFieldProps,
      placeholder: readOnly
        ? 'Ничего не выбрано'
        : textFieldProps.placeholder || 'Выбрать из списка',
      inputContainerClassName: clsx(classes.inputContainer, {
        [classes.selected]: Boolean(value) && selectedHighlight,
        [classes.readOnly]: readOnly,
      }),
      inputClassName: clsx(classes.input),
      endAdornment: readOnly ? null : (
        <SelectArrowIcon rotate={options.popupOpened ? 180 : 0} />
      ),
      tag: 'input',
      readOnly: true,
      valueOverflowEllipsis: forceTooltip,
    },
    bricksContainerProps: {
      className: clsx(classes.bricksContainer),
    },
    bricksPlaceholderProps: {
      className: clsx(classes.bricksPlaceholder),
    },
    brickProps: {
      className: clsx(classes.brick),
    },
    brickCloserContainerProps: {
      className: clsx(classes.brickCloserContainer),
    },
    popupContainerProps: {
      className: clsx(classes.popupContainer),
    },
    popupPaperProps: {
      className: clsx(classes.popupPaper),
    },
    popupOptionsListProps: {
      className: clsx(classes.popupOptionsList),
    },
    popupOptionProps: {
      className: clsx(classes.popupOption),
    },
    popupOptionInfoProps: {
      className: clsx(classes.popupOptionInfo),
    },
    popupOptionTextContainerProps: {
      className: clsx(classes.popupOptionTextContainer),
    },
    popupOptionTitleProps: {
      className: clsx(classes.popupOptionTitle),
    },
    popupOptionSubTitleProps: {
      className: clsx(classes.popupOptionSubTitle),
    },
    popupOptionIndicatorProps: {
      className: (isSelected) =>
        clsx(classes.popupOptionIndicator, {
          [classes.selected]: isSelected,
        }),
    },
    popupOptionImageProps: {
      className: classes.popupOptionImage,
    },
  };
};
